import React from 'react';
import { Alert, Typography } from 'antd';

import { useIsRoleIn } from '../../components/ButtonWithRole';
import { CAPABILITY_ROLES } from '@prerender/prerender-shared/FE';

// The same allow-list POST /api/toggle-pause-recaching reads (COR-839). An allow-list rather than
// a `disabledFor` deny-list because the control is a Typography.Link, which takes no `disabledFor`.
const CAN_RESUME_RECACHING = CAPABILITY_ROLES.contentWrite;

export const RecachingPausedMessage = ({ onResumeCaching }: { onResumeCaching: () => void }) => {
  const canResume = useIsRoleIn(CAN_RESUME_RECACHING);

  return (
    <Alert
      closable
      type="warning"
      message={
        <>
          <Typography.Text>Recaching is currently paused.</Typography.Text>
          {canResume && (
            <>
              {' '}
              <Typography.Link onClick={onResumeCaching}>Resume Caching</Typography.Link>
            </>
          )}
        </>
      }
    />
  );
};
